import Axios from "axios";

const UsersServices = {
  async create(params) {
    try {
      const res = await Axios.post("user/create", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async findAll(params) {
    try {
      const res = await Axios.post("user/all", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async findOne(params) {
    try {
      const res = await Axios.post("user/one", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async delete(params) {
    try {
      const res = await Axios.post("user/delete", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
  async update(params) {
    try {
      const res = await Axios.post("user/update", params);
      return res.data;
    } catch (err) {
      throw err.response.data;
    }
  },
};

export default UsersServices;
